import React, { useEffect, useState } from "react";
import { getAllQuestions, updateQuestion } from "../services/api"; // Assuming these functions are correctly imported

function QuestionList() {
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [filterType, setFilterType] = useState("question_id"); // Default filter type
  const [searchTerm, setSearchTerm] = useState("");

  const [editQuestion, setEditQuestion] = useState(null);
  const [updatedQuestionText, setUpdatedQuestionText] = useState("");
  const [updatedOptions, setUpdatedOptions] = useState([]);
  const [updatedIsActive, setUpdatedIsActive] = useState(1); // Active by default
  const [updatedHint, setUpdatedHint] = useState(""); // State for hint field

  const languageMap = {
    hi_IN: "Hindi",
    en_US: "English",
  };

   const projectMap = {
    jagranquiz: "Jagran",
    joshquiz: "Josh",
  };

  useEffect(() => {

    const userRole = sessionStorage.getItem("userRole");
        const userProject = sessionStorage.getItem("project");

        // Pass down project token query parameter if NOT super_admin
        const projectFilter = userRole !== "super_admin" ? userProject : null;
    const fetchQuestions = async () => {
      try {
        const response = await getAllQuestions(projectFilter);
        if (response.data.success) {
          setQuestions(response.data.data);
          setFilteredQuestions(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch questions.");
        }
      } catch (err) {
        setError("An error occurred while fetching questions.");
        console.error("Error fetching questions:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, []);

  const handleFilterChange = (e) => {
    setFilterType(e.target.value);
    setSearchTerm(""); // Reset search term when filter type changes
  };

  // const handleSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearchTerm(value);

  //   const filtered = questions.filter((question) => {
  //     const filterValue = question[filterType]?.toString().toLowerCase();
  //     return filterValue?.includes(value.toLowerCase());
  //   });
  //   setFilteredQuestions(filtered);
  // };


  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = questions.filter((question) => {
      let filterValue = "";

      // If filtering by project, map the raw key to the actual name first
      if (filterType === "project") {
        const rawProject = question.project;
        filterValue = (projectMap[rawProject] || rawProject || "").toString().toLowerCase();
      } else {
        // Default behavior for other fields
        filterValue = (question[filterType] || "").toString().toLowerCase();
      }

      return filterValue.includes(value);
    });
    setFilteredQuestions(filtered);
  };

  const handleEdit = (question) => {
    setEditQuestion(question);
    setUpdatedQuestionText(question.question);
    setUpdatedOptions(question.options);
    setUpdatedIsActive(question.is_active);
    setUpdatedHint(question.hint || ""); // Set the hint field
  };

  const handleUpdateQuestion = async () => {
    try {
      // Ensure editQuestion exists before spreading
      if (!editQuestion) {
        console.error("No question selected for update.");
        return;
      }
  
      const updatedQuestion = {
        question_id: editQuestion.question_id, // Ensure this is defined
        ...editQuestion,
        question: updatedQuestionText,
        options: updatedOptions,
        is_active: updatedIsActive,
        hint: updatedHint, // Include the hint field when updating
      };
  
      console.log("Updating question:", updatedQuestion);
  
      await updateQuestion(updatedQuestion);
  
      setQuestions((prev) =>
        prev.map((q) => (q.question_id === updatedQuestion.question_id ? updatedQuestion : q))
      );
  
      setFilteredQuestions((prev) =>
        prev.map((q) => (q.question_id === updatedQuestion.question_id ? updatedQuestion : q))
      );
  
      setEditQuestion(null); // Close the modal
    } catch (err) {
      console.error("Error updating question:", err);
    }
  };  

  if (loading) return <p>Loading questions...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Question List</h1>

      <div style={styles.filterContainer}>
        <label htmlFor="filterType" style={styles.filterLabel}>
          Filter by:
        </label>
        <select
          id="filterType"
          value={filterType}
          onChange={handleFilterChange}
          style={styles.dropdown}
        >
          <option value="question_id">Question ID</option>
          <option value="question">Question</option>
          <option value="quiz_id">Quiz ID</option>
          <option value="project">Project</option>
        </select>

        <input
          type="text"
          placeholder={`Search by ${filterType}`}
          value={searchTerm}
          onChange={handleSearchChange}
          style={styles.searchBox}
        />
      </div>

      {filteredQuestions.length === 0 ? (
        <p>No questions match your search criteria.</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.tableHeader}>Ques_ID</th>
              <th style={styles.tableHeader}>Question</th>
              <th style={styles.tableHeader}>Options</th>
              <th style={styles.tableHeader}>Language</th>
              <th style={styles.tableHeader}>Project</th>
              <th style={styles.tableHeader}>Level</th>
              <th style={styles.tableHeader}>Hint</th>
              <th style={styles.tableHeader}>QZ_ID</th>
              <th style={styles.tableHeader}>Active</th>
              <th style={styles.tableHeader}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredQuestions.map((question) => (
              <tr key={question._id} style={styles.tableRow}>
                <td style={styles.tableCell}>{question.question_id}</td>
                <td style={styles.tableCell}>{question.question}</td>
                <td style={styles.tableCell}>
                  <ul style={styles.optionList}>
                    {question.options.map((option, index) => (
                      <li
                        key={index}
                        style={{
                          ...styles.optionItem,
                          color: option.is_correct === "Y" ? "green" : "black",
                        }}
                      >
                        {option.text} {option.is_correct === "Y" && "(Correct)"}
                      </li>
                    ))}
                  </ul>
                </td>
                <td style={styles.tableCell}>
                  {languageMap[question.language] || question.language}
                </td>

                 <td style={styles.tableCell}>
                  {projectMap[question.project] || question.project}
                </td>

                <td style={styles.tableCell}>
                  {question.level?.level_name || "N/A"}
                </td>
                <td style={styles.tableCell}>{question.hint || "N/A"}</td>
                <td style={styles.tableCell}>{question.quiz_id}</td>
                <td style={styles.tableCell}>
                  {question.is_active ? "Yes" : "No"}
                </td>
                <td style={styles.tableCell}>
                  <button
                    onClick={() => handleEdit(question)}
                    style={styles.editButton}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Edit Question Modal */}
      {editQuestion && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modal}>
            <h2>Edit Question</h2>
            <label style={styles.label}>Question Text:</label>
            <input
              type="text"
              value={updatedQuestionText}
              onChange={(e) => setUpdatedQuestionText(e.target.value)}
              style={styles.input}
            />

            <label style={styles.label}>Options:</label>
            {updatedOptions.map((option, index) => (
              <div key={index} style={{ marginBottom: "10px" }}>
                <input
                  type="text"
                  value={option.text}
                  onChange={(e) => {
                    const newOptions = [...updatedOptions];
                    newOptions[index] = { ...newOptions[index], text: e.target.value };
                    setUpdatedOptions(newOptions);
                  }}
                  style={styles.input}
                />
                <label style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="radio"
                    name="correctOption"
                    checked={option.is_correct === "Y"}
                    onChange={() => {
                      const newOptions = updatedOptions.map((opt, i) => ({
                        ...opt,
                        is_correct: i === index ? "Y" : "N",
                      }));
                      setUpdatedOptions(newOptions);
                    }}
                    style={{ marginRight: "5px" }}
                  />
                  Correct
                </label>
              </div>
            ))}

            <label style={styles.label}>Hint:</label>
            <textarea
              value={updatedHint}
              onChange={(e) => setUpdatedHint(e.target.value)}
              style={styles.textarea}
            />

            <label style={styles.label}>Active:</label>
            <div>
              <label>
                <input
                  type="radio"
                  value={1}
                  checked={updatedIsActive === 1}
                  onChange={() => setUpdatedIsActive(1)}
                />
                Active
              </label>
              <label style={{ marginLeft: "10px" }}>
                <input
                  type="radio"
                  value={0}
                  checked={updatedIsActive === 0}
                  onChange={() => setUpdatedIsActive(0)}
                />
                Inactive
              </label>
            </div>

            <div style={styles.buttonContainer}>
              <button onClick={handleUpdateQuestion} style={styles.updateButton}>
                Update Question
              </button>
              <button
                onClick={() => setEditQuestion(null)}
                style={styles.cancelButton}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "30px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "20px",
    textAlign: "center",
  },
  filterContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  filterLabel: {
    marginRight: "10px",
    fontWeight: "bold",
  },
  dropdown: {
    padding: "8px",
    marginRight: "20px",
    fontSize: "16px",
  },
  searchBox: {
    flex: "1",
    padding: "8px",
    fontSize: "16px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#f8f9fa",
  },
  tableHeader: {
    backgroundColor: "#007bff",
    color: "#fff",
    textAlign: "left",
    padding: "10px",
  },
  tableRow: {
    borderBottom: "1px solid #ddd",
  },
  tableCell: {
    padding: "10px",
    textAlign: "left",
  },
  optionList: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
  },
  optionItem: {
    marginBottom: "5px",
  },
  editButton: {
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
  },
  modalBackdrop: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    backgroundColor: "white",
    padding: "30px",
    borderRadius: "10px",
    width: "500px",
    maxHeight: "80vh", // Make modal scrollable
    overflowY: "auto", // Enable vertical scroll
  },
  label: {
    fontWeight: "bold",
    marginTop: "10px",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    border: "1px solid #ddd",
    borderRadius: "5px",
  },
  textarea: {
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    height: "100px", // Increased height for hint field
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  updateButton: {
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "#dc3545",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
  },
};

export default QuestionList;
